import ApiService from "./APIServices";

import APIConfig from "./APIConfig";

class ChatBotServices {
  constructor() {
    this.apiService = new ApiService();
  }
  getOTP(email, utms = { utm1: "", utm2: "", utm3: "" }, onSuccess, onError) {
    const url = APIConfig.chatBot.getOTP;
    let Obj = {
      email: email,
      utm1: utms.utm1,
      utm2: utms.utm2,
      utm3: utms.utm3,
    };
    this.apiService.post(
      url,
      Obj,
      (response) => {
        onSuccess(response);
      },
      onError
    );
  }
  verifyOTP(params, onSuccess, onError) {
    const url = APIConfig.chatBot.verifyOTP;
    this.apiService.post(
      url,
      params,
      (response) => {
        onSuccess(response);
      },
      onError
    );
  }
  getNextQuestion(slug, onSuccess, onError) {
    const url = APIConfig.chatBot.nextQuestion;
    this.apiService.get(
      url,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
      {
        client: "web",
        auth_token: slug,
      }
    );
  }
  submitAnswer(slug, params, onSuccess, onError) {
    const url = APIConfig.chatBot.submitAnswer;
    this.apiService.post(
      url,
      params,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
      {
        client: "web",
        auth_token: slug,
        "Content-Type": "application/json",
      }
    );
  }
  getAllAnswers(slug, onSuccess, onError) {
    const url = APIConfig.chatBot.getallAnswers;
    this.apiService.get(
      url,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
      {
        client: "web",
        auth_token: slug,
      }
    );
  }
  getEmail(header, onSuccess, onError) {
    const url = APIConfig.chatBot.getEmail;
    this.apiService.get(
      url,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
      header
    );
  }
  undoQuestion(slug, params, onSuccess, onError) {
    const url = APIConfig.chatBot.undoQuestion;
    this.apiService.post(
      url,
      params,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
      {
        client: "web",
        auth_token: slug,
        "Content-Type": "application/json",
      }
    );
  }
  getScore = (slug, onSuccess, onError) => {
    const url = APIConfig.chatBot.getScore;
    this.apiService.get(
      url,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },

      {
        client: "web",
        auth_token: slug,
      }
    );
  };
}

export default ChatBotServices;
